import React from 'react';
import './Common.css';

function Table({ columns, data, loading, onEdit, onDelete, actions = true, customActions, rowClassName }) {
  const showActionsColumn = actions || !!customActions;
  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="no-data">Aucune donnée disponible</div>;
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
            {showActionsColumn && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className={rowClassName ? rowClassName(row) : ''}>
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
              {showActionsColumn && (
                <td>
                  <div className="action-buttons">
                    {actions && onEdit && (
                      <button
                        onClick={() => onEdit(row)}
                        className="btn btn-small btn-edit"
                      >
                        Modifier
                      </button>
                    )}
                    {actions && onDelete && (
                      <button
                        onClick={() => onDelete(row.id)}
                        className="btn btn-small btn-delete"
                      >
                        Supprimer
                      </button>
                    )}
                    {customActions && customActions(row)}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
